module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAv0lEQVRYR+2WwQ3CMAxF/5+AEdoNYIRuUEaBCYAJukrZgG7ACmzQTmBkiSCrJ18sX+xbFMt5+XG+TCQHk89HAZQCFJEeQGeacSP5bmsROQE4BDXrRwEuACZzwEJyMAAKcwwCuFYPlAKlQL4CIqJ//mb++Yvkw/iA+sQY5ANPNSIFuO8A/uufUZ2DAOb8Jwi6mbtsKVAK5CvgGEjUE6xRuTvckbi0kUzHshbrbiTTPbvvqOtOWfOfwM0alFgKlAJfoeI4bxW43zYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/header/images/Category.png
// module id = 174
// module chunks = 0